<div #mainContainerCustomTooltip id="toast-main-container" class="main-container">
    <div id="toast-content-container" class="content-container">
        <span id="toast-span" class="content-span">{{tooltipContent}}</span>
    </div>   
</div>